import { useTranslation } from 'react-i18next';
import { KnowledgeBaseSection } from '@features/user/knowledgeBase';
import { Button, Card } from '@features/ui';
import { useEffect, useState } from 'react';
import { QuestionIcon, BulbIcon, OutlineEmailIcon } from '@features/ui/icons';
import {
  getKnowledgeBases,
  KnowledgeBaseGroupByTypeRead,
} from '@src/services/knowledgeBase';
import { TSectionCollapsible } from '@src/types';

export const KnowledgeBasePage = () => {
  const { t } = useTranslation();
  const [sections, setSections] = useState<
    { groupName: string; type_id: number; items: TSectionCollapsible[] }[]
  >([]);

  useEffect(() => {
    let mounted = true;

    const load = async () => {
      try {
        const res = await getKnowledgeBases();
        const groups: KnowledgeBaseGroupByTypeRead[] = res.data ?? [];

        // Backend already returns data grouped and sorted by type.sort_order
        const mapped = groups.map((g) => ({
          groupName: g.name,
          type_id: g.type_id,
          items: g.knowledge.map((it) => ({
            id: String(it.id),
            title: it.name,
            description: it.content ?? '',
          })),
        }));

        if (mounted) setSections(mapped);
      } catch {
        // fallback to empty
      }
    };

    load();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div>
      <div className={'flex gap-x-11 gap-y-4 flex-wrap mb-5.5'}>
        <Button className={'text-[#3490FF] underline'} variant={'link'}>
          <BulbIcon />
          <p className={'text-[19px] font-medium'}>
            {t('knowledgeBase.linkLabel1')}
          </p>
        </Button>
        <Button
          className={'text-[#14CA74] underline'}
          variant={'link'}
          onClick={() => window.open(`mailto:support@leelootrading.com`)}
        >
          <OutlineEmailIcon />
          <p className={'text-[19px] font-medium'}>
            {t('knowledgeBase.linkLabel2')}
          </p>
        </Button>
      </div>
      <Card className={'gap-y-5'}>
        {sections.map((s) => (
          <KnowledgeBaseSection
            key={s.type_id}
            data={s.items}
            iconComponent={<QuestionIcon />}
            title={s.groupName}
          />
        ))}
      </Card>
    </div>
  );
};
